import { SetStateAction, useEffect, useRef, useState } from "react";
import axios from "../scripts/axiosConfig";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import OTPInput from "react18-input-otp";

import { FaArrowRightLong } from "react-icons/fa6";
import { IoShieldCheckmark } from "react-icons/io5";

import "../styles/ForgotPassword.scss";
import { FiLoader } from "react-icons/fi";
import CLink from "../components/CLink";

export default function ForgotPassword() {

    const [pageToShow, setPageToShow] = useState<"enter_email" | "enter_otp" | "new_password">("enter_email");
    const [getOtpLoading, setGetOtpLoading] = useState<boolean>(false);
    const [verifyOtpLoading, setVerifyOtpLoading] = useState<boolean>(false);
    const [resetPasswordLoading, setResetPasswordLoading] = useState<boolean>(false);

    const [searchParams, setSearchParams] = useSearchParams();
    const email = searchParams.get("email");

    const [enteredEmail, setEnteredEmail] = useState<string | null>(null);
    const [otp, setOtp] = useState<string>("");

    const form = useRef<HTMLFormElement>(null);

    const getOtpRequest = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        console.log("Send for got pasd po ");
        let email = form.current?.email?.value 
        if (email) {
            setGetOtpLoading(true);
            axios.post(
                "/users/forgot-password", 
                { 'email': email },
            )
            .then((res) => {
                console.log("Forgot password request sent successfully:", res);
                toast.success(
                    res.data.message,
                    { autoClose: 10000 }
                );
                if (res.data.code == "forgot_password_email_sent") {
                    setEnteredEmail(email);
                    setPageToShow("enter_otp");
                }
                setGetOtpLoading(false);
            })
            .catch((err) => {
                setGetOtpLoading(false);
                console.error("Error occurred while sending forgot password request:", err);
                // toast.error(err.response.data.error || err.message);
                // toast.error("<a href='www.google.com'>SS</a>")
                if (err.response.data.errorCode == "NO_ACCOUNT_FOUND") {
                    toast(
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <span>{err.response.data.error}
                          <CLink
                            to={`/signup?email=${form.current?.email?.value}`}
                            style={{
                                display: "inline-block",
                                fontSize: "12px",
                                fontWeight: "600",
                                marginLeft: ".4rem",
                                padding: ".15rem .4rem",
                                backgroundColor: "rgb(54, 233, 87)",
                                color: "#111",
                                border: "1px solid rgba(35, 66, 26, 0.3)",
                                borderRadius: "4px",
                                cursor: "pointer",
                            }}
                          >
                            Sign Up?
                          </CLink>
                          </span>
                          
                        </div>,
                        {
                            autoClose: 10000
                        }
                    );
                }
                else {
                    toast.error(<div dangerouslySetInnerHTML={{ __html: err.response.data.error || err.message }} />)
                }
  
            })
        }   
    }

    const verifyOTPRequest = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        console.log("Send verify OTP request");
        // let otp = form.current?.otp?.value;
        if (otp) {
            setVerifyOtpLoading(true);
            axios.post(
                "/users/verify-otp", 
                { 'email': enteredEmail, 'otp': otp },
            )
            .then((res) => {
                console.log("Verify OTP request sent successfully:", res);
                toast.success(res.data.message, { autoClose: 1000 });
                if (res.data.code == "otp_verification_success") {
                    setPageToShow("new_password");
                }
                setVerifyOtpLoading(false);
            })
            .catch((err) => {
                setVerifyOtpLoading(false);
                console.error("Error occurred while sending verify OTP request:", err);
                toast.error(err.response.data.error || err.message, { autoClose: 2000 });
                setOtp("");
            })
        }
        else {
            toast.error("Please enter the OTP sent to your email");
        }
    }

    const resetPasswordRequest = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        let password = form.current?.password?.value;
        let confirm_password = form.current?.confirm_password?.value;
        if ( password !== confirm_password ) {
            toast.error("Passwords do not match");
            return;
        }

        console.log("Sending reset password request");

        if (otp && password) {
            setResetPasswordLoading(true);
            axios.post(
                "/users/reset-password", 
                { 'email': enteredEmail, 'otp': otp, 'newPassword': password },
            )
            .then((res) => {
                console.log("Reset password request sent successfully:", res);
                toast.success(res.data.message);
                if (res.data.code == "password_reset") {
                    setPageToShow("new_password");
                }
                setResetPasswordLoading(false);
            })
            .catch((err) => {
                setResetPasswordLoading(false);
                console.error("Error occurred while sending reset password request:", err);
                toast.error(err);
            })
        }   
    }

    useEffect(() => {
        console.log(`Email is: ${email}`);
        if (email) {
            if (form.current) {
                (form.current?.email as HTMLInputElement).value = email;
            }
        }
        
    }, []);

    return (
        <div className="forgotPassword">
            {
            (pageToShow === "enter_email") && 
            (
                <div className="formContainer emailForm">
                    <h2>Forgot Password?</h2>
                    <h4>
                        Don't worry! Happens to the best of us.
                    </h4>
                    <form ref={form} onSubmit={getOtpRequest}>
                        <div className="inputContainer emailContainer">
                            <label htmlFor="email">Enter your Email</label>
                            <input type="email" id="email" name="email" required title="Enter your email" />
                        </div>
                        <button disabled={getOtpLoading} className={(getOtpLoading) ? "loading" : ""} type="submit">
                            {
                                ( getOtpLoading ) ? 
                                    <FiLoader className="loader" />
                                :
                                <>
                                    Get OTP
                                    <FaArrowRightLong />
                                </>
                            }
                        </button>
                    </form>
                </div>
            )
            }
            {
            (pageToShow === "enter_otp") && 
            (
                <div className="formContainer otpForm">
                    <h2>Enter OTP</h2>
                    <h4>
                        A 6-digit code has been sent to <span className="email">{enteredEmail}</span>
                        <br />
                        The code is valid for 10 minutes. 
                    </h4>

                    <button className="goBack" onClick={() => {
                        setOtp("");
                        setPageToShow("enter_email");
                    }}>
                        Wrong Email?
                    </button>
                    <form ref={form} onSubmit={verifyOTPRequest}>
                        <div className="inputContainer otpContainer">
                        <OTPInput
                            value={otp}
                            onChange={(val: SetStateAction<string>) => setOtp(val)}
                            shouldAutoFocus
                            numInputs={6}
                        />
                        </div>
                        <button disabled={verifyOtpLoading || (otp.length != 6)} className={(verifyOtpLoading) ? "loading" : ""} type="submit">
                            {
                                ( verifyOtpLoading ) ? 
                                    <FiLoader className="loader" />
                                :
                                <>
                                    Verify OTP
                                    <IoShieldCheckmark  />
                                </>
                            }
                        </button>
                    </form>
                </div>
            )
            }
            {
            (pageToShow === "new_password") && 
            (
                <div className="formContainer newPasswordForm">
                    <h2>Enter New Password</h2>
                    <form ref={form} onSubmit={resetPasswordRequest}>
                        <div className="inputContainer newPasswordContainer">
                            <label htmlFor="password">New Password:</label>
                            <input type="password" id="password" name="password" required title="Enter your new password" />
                            <br />
                            <label htmlFor="password">Confirm new Password:</label>
                            <input type="password" id="confirm_password" name="confirm_password" required title="Confirm your new password" />
                        </div>
                        <button type="submit">Submit</button>
                    </form>
                </div>
            )
            }
        </div>
    );
};